module.exports = __webpack_public_path__ + "static/media/bottom_img.239ad989.png";